import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRevisionIndependentGet = {
    path: "/revision/independent/:hash",
    method: RouteHttpVerb.GET
};
